"use client";
import React from "react";
import { Row, Col } from "react-bootstrap";
import "./SpecializationLeadership.css";

const SpecializationLeadership = ({ headingColor = " rgb(173, 49, 77)" }) => {

  return (
    <section class="leardership-specialization">
      <div class="container-lg">
        <div class="row">
          <div class="first-box mb-md-3 mb-sm-3 mb-3">
            <div class="card_holder">
              <div class="row justify-content-center align-items-center">
                <div class="col-xl-4 col-md-5 col-sm-7 col-10 order-lg-1 order-2 ">
                  <div class="image-holder">
                    <img
                      loading="lazy"
                      class="student-img"
                      alt="Online Master of Computer Application"
                      src="/assets/images/Banner/1767161265526-MCA DY.webp"
                    />
                  </div>
                </div>
                <div class="col-xl-7 col-md-7 order-lg-2 order-1 ">
                  <div class="card-holder">
                    <h1 class="card_name" style={{ color: headingColor }}>
                      Online Master of Computer Application <br />
                      <strong></strong>
                    </h1>
                    <div>
                      <p>
                        DPUCOL’s Online Master of Computer Applications (MCA) is
                        designed to do more than award a qualification—it
                        prepares you for real-world tech careers. Approved by
                        AICTE and UGC, this two-year postgraduate program
                        combines strong academic foundations with practical,
                        industry-focused learning, all delivered fully
                        online.{" "}
                      </p>
                      <p>
                        <br />
                      </p>
                      <p>
                        Ideal for fresh graduates as well as working
                        professionals, the program allows you to:{" "}
                      </p>
                      <ul>
                        <li>
                          Develop in-demand skills in software development, data
                          science, artificial intelligence, and related
                          domains.{" "}
                        </li>
                        <li>
                          Learn with complete flexibility, accessing
                          high-quality education from anywhere at your
                          convenience.{" "}
                        </li>
                        <li>
                          Gain a globally recognized degree without interrupting
                          your professional or personal commitments
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="specialization_div">
          <h2 class="text-left fw-bold mb-4">Specializations</h2>
          <div class="specialization-grid">
            <div class="spec-card">Artificial Intelligence &amp; ML</div>
            <div class="spec-card">Blockchain Technology</div>
            <div class="spec-card">Business Analytics</div>
            <div class="spec-card">Digital Marketing</div>
            <div class="spec-card">FinTech</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecializationLeadership;
